import { render, staticRenderFns } from "./AddCpvModal.vue?vue&type=template&id=31dd13d8&scoped=true"
import script from "./AddCpvModal.vue?vue&type=script&lang=js"
export * from "./AddCpvModal.vue?vue&type=script&lang=js"
import style1 from "./AddCpvModal.vue?vue&type=style&index=1&id=31dd13d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd13d8",
  null
  
)

export default component.exports